import Person from "@/models/Customers/People/Person";

export default (value: Person) => {
    let name = "";
    if (value.title !== "" && value.title !== undefined) {
        name = value.title + ".";
    }
    if (value.firstName !== "" && value.firstName !== undefined) {
        if (name !== "") {
            name = name + " ";
        }
        name = name + value.firstName;
    }
    if (value.lastName !== "" && value.lastName !== undefined) {
        if (name !== "") {
            name = name + " ";
        }
            name = name + value.lastName;
    }
    if (name === "" && name !== undefined) {
        name = "Undefined";
    }
    return name;
}